// URL de base pour l'API backend
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const convertProspectToCompany = async (prospectCompanyId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/convertProspectCompany`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            body: JSON.stringify({ prospectCompanyId })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Une erreur inattendue est survenue lors de la conversion.');
        }

        return data;
    } catch (error) {
        console.error('Erreur lors de la conversion de l\'entreprise prospect:', error);
        if (error.message.includes('Failed to fetch')) {
            throw new Error('Erreur de connexion au serveur. Veuillez réessayer.');
        }
        throw error;
    }
};


